/* Blak Sand — the product page (16 Sep 2026).
   Frames that turn on touch with a segmented rule; colour and size as plain buttons
   that resolve to one variant; the dock that mirrors the choice; the size guide;
   the note to the maker mirrored into the form; and the recently-viewed list.
   Left/right arrow buttons added 23 Sep 2026 (Anuj): wired to the same goTo()
   the dashes and arrow keys already use.
   19 Oct 2026 (Anuj), build packet: the colour buttons are leather dots
   (snippets/bs-colour-dots.liquid) and the label reads "Dark Brown, tumbled pull-up";
   Made for you lives in its own file, bs-mfy.js, loaded only when the theme setting is
   on. It talks to this file through window.bsPP: bsPP.mfy is her choice or null,
   bsPP.refresh() repaints, bsPP.onReset() is called when she picks a normal colour.
   A made-for-you pair is never blocked by the photographed colour's stock. */
(function () {
  'use strict';
  var root = document.querySelector('.bs-pp');
  if (!root) return;
  var data;
  try { data = JSON.parse(document.getElementById('bsProductData').textContent); } catch (e) { return; }
  var $ = function (id) { return document.getElementById(id); };
  if (!$('bsForm')) return; // the old charge product's page has no form (not sold on its own)

  // ---- frames ----
  var frames = $('bsFrames'), seg = $('bsSeg');
  var segs = seg ? Array.prototype.slice.call(seg.children) : [];
  function frameIndex() {
    if (!frames) return 0;
    var w = frames.clientWidth || 1;
    return Math.round(frames.scrollLeft / w);
  }
  function markSeg() {
    var i = frameIndex();
    segs.forEach(function (s, k) { s.classList.toggle('on', k === i); });
  }
  function goTo(i) {
    if (!frames) return;
    var n = frames.children.length;
    i = ((i % n) + n) % n;
    frames.scrollTo({ left: i * frames.clientWidth, behavior: 'smooth' });
  }
  if (frames) {
    var t;
    frames.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(markSeg, 60); }, { passive: true });
    // a tap on the picture turns it, as on the mock
    frames.addEventListener('click', function (e) {
      if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) return; // desktop: let a click be a click
      var r = frames.getBoundingClientRect();
      goTo(frameIndex() + ((e.clientX - r.left) < r.width * 0.3 ? -1 : 1));
    });
    frames.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') goTo(frameIndex() + 1);
      if (e.key === 'ArrowLeft') goTo(frameIndex() - 1);
    });
    segs.forEach(function (s, k) { s.addEventListener('click', function () { goTo(k); }); });
    // left/right arrow buttons over the image — same goTo() as the dashes and keys
    var prevBtn = $('bsPrev'), nextBtn = $('bsNext');
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(frameIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(frameIndex() + 1); });

    // ---- warm the rest of the frames (24 Sep 2026, Anuj) ----
    // Frames 4 onward are loading="lazy". On a phone a quick swipe outruns a lazy
    // fetch and she sees a grey box, so once the page has settled, or the moment she
    // touches the gallery, every remaining frame is fetched ahead of her swipe.
    var warmed = false;
    var warmFrames = function () {
      if (warmed) return; warmed = true;
      Array.prototype.forEach.call(frames.querySelectorAll('img[loading="lazy"]'), function (im) {
        try {
          var pre = new Image();
          if (im.sizes) pre.sizes = im.sizes;
          if (im.srcset) pre.srcset = im.srcset;
          pre.src = im.src;
        } catch (e) {}
        im.loading = 'eager';
      });
    };
    ['touchstart', 'pointerdown', 'scroll'].forEach(function (ev) {
      frames.addEventListener(ev, warmFrames, { passive: true, once: true });
    });
    if (prevBtn) prevBtn.addEventListener('pointerdown', warmFrames, { passive: true });
    if (nextBtn) nextBtn.addEventListener('pointerdown', warmFrames, { passive: true });
    if (document.readyState === 'complete') setTimeout(warmFrames, 1200);
    else window.addEventListener('load', function () { setTimeout(warmFrames, 1200); });
  }

  // ---- variant resolve ----
  var sel = { colour: null, size: null }, shownColour = null;
  var swatches = $('bsSwatches'), sizes = $('bsSizes');
  var ck = 'o' + data.colourIdx, sk = 'o' + data.sizeIdx;
  // the hand-off to bs-mfy.js (only present when Made for you is switched on)
  var api = window.bsPP = { mfy: null, sel: sel, onReset: null, refresh: function () { paintSizes(); apply(); } };
  function first(fn) { for (var i = 0; i < data.variants.length; i++) if (fn(data.variants[i])) return data.variants[i]; return null; }
  if (swatches) {
    var on = swatches.querySelector('[aria-checked="true"]');
    sel.colour = on ? on.dataset.value : null;
  }
  function colourLabel() {
    var b = swatches && swatches.querySelector('[aria-checked="true"]');
    return (b && (b.getAttribute('data-label') || b.dataset.value)) || sel.colour;
  }
  function variantFor(colour, size) {
    return first(function (v) {
      return (data.colourIdx === 0 || v[ck] === colour) && (data.sizeIdx === 0 || v[sk] === size);
    });
  }
  // a made-for-you pair is cut after she orders, so the photographed colour's stock never blocks it
  function canBuy(v) { return !!(v && (v.available || api.mfy)); }
  function paintSizes() {
    if (!sizes) return;
    Array.prototype.forEach.call(sizes.children, function (b) {
      var v = variantFor(sel.colour, b.dataset.value);
      var ok = canBuy(v);
      b.disabled = !ok;
      b.setAttribute('aria-checked', String(sel.size === b.dataset.value && ok));
    });
  }
  function apply() {
    var v = (data.sizeIdx === 0 || sel.size) ? variantFor(sel.colour, sel.size) : null;
    var idInput = $('bsVariantId');
    var atc = $('bsAtc'), dockAtc = $('bsDockAtc');
    if (v) {
      idInput.value = v.id;
      $('bsForm').dataset.productid = v.id;
      idInput.dataset.productid = v.id;
      // v.price is the already-rendered money markup (money_without_trailing_zeros in
      // bs-product.liquid, e.g. <span class="money">₹9,199</span>) — it must be parsed
      // as HTML, not dropped in as literal text, or the markup shows up as visible text
      // and its length breaks the flex row it shares with the title.
      if ($('bsPrice')) $('bsPrice').innerHTML = v.price;
      var soldOut = !canBuy(v);
      atc.disabled = soldOut; if (dockAtc) dockAtc.disabled = soldOut;
      atc.querySelector('span').textContent = soldOut ? 'Sold out' : 'Add To Cart';
      if (dockAtc) dockAtc.textContent = soldOut ? 'Sold out' : 'Add To Cart';
    } else {
      atc.disabled = false; if (dockAtc) dockAtc.disabled = false;
      atc.querySelector('span').textContent = 'Add To Cart';
      if (dockAtc) dockAtc.textContent = 'Add To Cart';
    }
    // the gallery turns to her colour's run — the frame whose alt reads ", <Colour> — 01" —
    // whether or not a size is chosen yet; failing that, the colourway's own variant picture
    if (frames && sel.colour && sel.colour !== shownColour) {
      shownColour = sel.colour;
      var f = null, needle = ', ' + sel.colour.toLowerCase() + ' — 01 ';
      Array.prototype.forEach.call(frames.querySelectorAll('img'), function (im) { if (!f && (im.getAttribute('alt') || '').toLowerCase().indexOf(needle) !== -1) f = im.closest('.bs-pp__frame'); });
      if (!f) { var cv = first(function (x) { return data.colourIdx === 0 || x[ck] === sel.colour; }); if (cv && cv.media) f = frames.querySelector('[data-media-id="' + cv.media + '"]'); }
      if (f) goTo(Array.prototype.indexOf.call(frames.children, f));
    }
    if ($('bsColour') && sel.colour) $('bsColour').textContent = api.mfy ? 'Made for you, ' + api.mfy.label : colourLabel();
    if ($('bsSizeLabel')) $('bsSizeLabel').textContent = sel.size ? 'Size ' + sel.size : 'Size';
    if ($('bsDockTxt')) $('bsDockTxt').textContent = [api.mfy ? api.mfy.label : sel.colour, sel.size].filter(Boolean).join(' / ') || 'Choose a size';
    var nudge = $('bsNudge'); if (nudge && sel.size) nudge.hidden = true;
    try {
      if (v && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); }
    } catch (e) {}
  }
  if (swatches) swatches.addEventListener('click', function (e) {
    var b = e.target.closest('.bs-pp__swb'); if (!b) return;
    sel.colour = b.dataset.value;
    Array.prototype.forEach.call(swatches.querySelectorAll('.bs-pp__swb'), function (x) { x.setAttribute('aria-checked', String(x === b)); });
    if (api.mfy && api.onReset) api.onReset(); // a normal colour cancels a made-for-you choice
    paintSizes(); apply();
  });
  if (sizes) sizes.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || b.disabled) return;
    sel.size = b.dataset.value;
    paintSizes(); apply();
  });
  // arriving from the stream in her colour (?c=<colourway>, arrival rule 18 Sep):
  // select that swatch as if she had tapped it, then let apply() write the variant
  (function () {
    if (!swatches || /[?&]variant=/.test(location.search)) return;
    var want = new URLSearchParams(location.search).get('c'); if (!want) return;
    var b = null;
    Array.prototype.forEach.call(swatches.querySelectorAll('.bs-pp__swb'), function (x) { if (!b && String(x.dataset.value || '').toLowerCase() === want.toLowerCase()) b = x; });
    if (!b) return;
    sel.colour = b.dataset.value;
    Array.prototype.forEach.call(swatches.querySelectorAll('.bs-pp__swb'), function (x) { x.setAttribute('aria-checked', String(x === b)); });
  })();
  paintSizes(); apply();
  // arriving from a finish shelf (?variant=…) or from the stream in her colour (?c=…):
  // open on that colourway's frame, without animation
  (function () {
    if (!frames || !sel.colour || frames.dataset.colourLed || !/[?&](variant|c)=/.test(location.search)) return;
    var f = null, needle = ', ' + sel.colour.toLowerCase() + ' — 01 ';
    Array.prototype.forEach.call(frames.querySelectorAll('img'), function (im) { if (!f && (im.getAttribute('alt') || '').toLowerCase().indexOf(needle) !== -1) f = im.closest('.bs-pp__frame'); });
    if (!f) { var v = first(function (x) { return data.colourIdx === 0 || x[ck] === sel.colour; }); if (v && v.media) f = frames.querySelector('[data-media-id="' + v.media + '"]'); }
    var i = f ? Array.prototype.indexOf.call(frames.children, f) : -1;
    if (i > 0) { frames.scrollTo({ left: i * frames.clientWidth, behavior: 'auto' }); markSeg(); }
  })();

  // a size must be chosen before anything goes to the cart (this listener runs before bs-mfy.js's)
  function needsSize() { return data.sizeIdx > 0 && !sel.size; }
  var form = $('bsForm');
  form.addEventListener('submit', function (e) {
    if (needsSize()) {
      e.preventDefault(); e.stopImmediatePropagation();
      $('bsNudge').textContent = 'Choose a size';
      $('bsNudge').hidden = false;
      sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);
  if ($('bsDockAtc')) $('bsDockAtc').addEventListener('click', function () {
    if (needsSize()) { $('bsNudge').hidden = false; sizes.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    // hand it to the theme's ajax cart through the real button
    $('bsAtc').click();
  });
  if ($('bsDockV')) $('bsDockV').addEventListener('click', function () {
    (sizes || swatches || root).scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // the dock shows once the first Add To Cart has scrolled away
  var dock = $('bsDock'), atcBtn = $('bsAtc');
  if (dock && atcBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      dock.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(atcBtn);
  }

  // ---- note to the maker ----
  var ta = $('bs-maker-note'), hid = $('bsNoteHidden');
  if (ta && hid) {
    var sync = function () { var v = ta.value.trim(); hid.value = v; hid.disabled = v.length === 0; };
    ta.addEventListener('input', sync); sync();
  }

  // ---- size guide ----
  var dlg = $('bsGuide');
  if (dlg && $('bsGuideOpen')) {
    $('bsGuideOpen').addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
    $('bsGuideClose').addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  // ---- recently viewed (client side, per browser) ----
  try {
    var key = 'bs-recent';
    var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (x) { return x.handle !== data.handle; });
    list.unshift({ handle: data.handle, title: data.title, url: data.url, image: data.image, price: data.price });
    localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
  } catch (e) {}
})();
